import React, { ComponentType, ComponentProps } from 'react';
import { components, ValueContainerProps, SingleValueProps, MultiValueProps } from 'react-select';

import { Select2, Text, TrashCan, cn } from 'Modules/ui';
import { useTranslation } from 'Modules/core/i18n';

import { usePaginationFilter, PaginationFilterField } from '../../utils';
import styles from './index.module.scss';


const ValueContainer: ComponentType<ValueContainerProps<any, true>> = ({ className, ...props }) => (
    <components.ValueContainer className={cn(styles.valueContainer, className)} {...props} />
);

const SingleValue: ComponentType<SingleValueProps<any>> = ({ children, ...props }) => (
    <components.SingleValue {...props}>
        <span title={props.data.label}>{children}</span>
    </components.SingleValue>
);

const MultiValue: ComponentType<MultiValueProps<any>> = React.memo(({ className, ...props }) => (
    <components.MultiValue className={cn(styles.itemContainer, className)} {...props} />
));

const MultiValueLabel: ComponentType<MultiValueProps<any>> = React.memo(props => (
    <Text<ComponentProps<'div'>> component='div' ellipsis title={props.data.label}>
        <components.MultiValueLabel {...props} />
    </Text>
));

const MultiValueRemove: ComponentType<MultiValueProps<any>> = React.memo(props => (
    <div className={styles.removeItem}>
        <components.MultiValueRemove {...props}>
            <TrashCan />
        </components.MultiValueRemove>
    </div>
));

type TemplateSelectFieldType = PaginationFilterField &
Omit<ComponentProps<typeof Select2>, 'value' | 'onChange'>;

export const PaginationSelectFilterField: ComponentType<TemplateSelectFieldType> = React.memo(({
    path,
    field,
    components,
    ...props
}) => {
    const { value, onChange } = usePaginationFilter<any>(path, field);

    const { t } = useTranslation('paginationSelectFilterField');

    return (
        <Select2
            value={value}
            onChange={onChange}
            className={styles.select}
            components={{
                MultiValue,
                ValueContainer,
                MultiValueRemove,
                MultiValueLabel,
                SingleValue,
                ...components,
            }}
            clearable
            noOptionsMessage={t('noOptions') as string}
            placeholder={t('placeholder') as string}
            {...props}
        />
    );
});
